export const CONFIG = {
  canvas: {
    width: 480,
    height: 624,
  },
  player: {
    width: 44,
    height: 47,
    duckWidth: 56,
    duckHeight: 26,
    startX: 40,
    standingY: 483,
    gravity: 0.6,
    jumpVelocity: -11,
  },
  game: {
    initialSpeed: 6,
    maxSpeed: 13,
    speedAcceleration: 0.001,
    groundY: 530,
  },
  obstacle: {
    minGapFrames: 40,
    extraGapFrames: 50,
  },
  cloud: {
    minGapFrames: 60,
    extraGapFrames: 180,
  },
  score: {
    pointsPerFrame: 0.1,
    storageKey: 'trex.highScore',
  },
  grave: {
    // 인접 grave 끼리 점수 간격이 좁으면 시각적으로 겹쳐서 1개만 노출.
    // 단, top N 은 간격과 minScore 무관하게 항상 표시.
    minScore: 6,
    minScoreGap: 18,
    alwaysShowTopN: 5,
  },
} as const;
